import { createIcon } from '@chakra-ui/react';

export const PlusIcon = createIcon({
	viewBox: '0 0 13 13',
	d: 'M6.94444 0.694444C6.94444 0.310913 6.63353 0 6.25 0C5.86647 0 5.55556 0.310913 5.55556 0.694444V5.55556H0.694444C0.310913 5.55556 0 5.86647 0 6.25C0 6.63353 0.310913 6.94444 0.694444 6.94444H5.55556V11.8056C5.55556 12.1891 5.86647 12.5 6.25 12.5C6.63353 12.5 6.94444 12.1891 6.94444 11.8056V6.94444H11.8056C12.1891 6.94444 12.5 6.63353 12.5 6.25C12.5 5.86647 12.1891 5.55556 11.8056 5.55556H6.94444V0.694444Z',
});
